import React, { Component, Fragment } from 'react';
import { Row, Col, InputGroup, FormControl, Button, Card, DropdownButton, Dropdown } from 'react-bootstrap';
import env from '../../env';
import Alerts from '../../components/alerts';
import PayloadResponse from '../../components/payloadResponse';
import UrlParams from '../../components/urlParams';
import service from '../../services/apiTestService';

class ApiTest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			searchValue: null,
			payload: null,
			alerts: [],
			params: [],
			endpointList: [],
		}
	}

	componentWillMount() {
		this.setState({endpointList: []});
		fetch('data/endpoint.json')
			.then((response) => response.json())
			.then((data) => {
				if (data !== null) {
					this.setState({endpointList: data});
				}
			});
	}

	setSearchValue = (event) => {
		const searchValue = event.target.value;
		this.setState({searchValue: searchValue});
		this.retrieveParamsFromInput(searchValue);
	}

	pressEnter = (target) => {
		if(target.charCode === 13 && this.state.searchValue != null) {
			this.doSearch();
		}
	}

	onDropdownSelect = (index) => {
		const updatedSearchValue = this.state.endpointList[index].endpoint;
		this.setState({searchValue: updatedSearchValue});
		this.retrieveParamsFromInput(updatedSearchValue);
	}

	retrieveParamsFromInput = (searchValue) => {
		const url = new URL(env.baseUrl + searchValue);
		
		let newParams = [];

		for (var p of url.searchParams) {
			const param = {
				key: p[0],
				value: p[1],
			}
			newParams.push(param);
		}

		this.setState({params: newParams});
	}

	onParamChange = (index, newVal, isKeyParam) => {
		this.setState((currentState) => {
			const params = [...currentState.params];

			if (index === params.length && isKeyParam) {
				params.push({});
			}

			if (isKeyParam) {
				params[index].key = newVal;
			} else {
				params[index].value = newVal;
			}

			currentState.searchValue = this.updateSearchValue(params);

			return {params}
		});
	}

	updateSearchValue = (params) => {
		const url = new URL(env.baseUrl + this.state.searchValue);

		let paramsArray = [];
		for (var p of params) {
			paramsArray.push(p.key + '=' + (p.value || ''));
		}

		const endpoint = (url.origin + url.pathname).replace(env.baseUrl, '');
		const paramsString = paramsArray.join('&');
		
		return (endpoint !== 'null' ? endpoint : '') + '?' + paramsString;
	}

	doSearch = async () => {
		if (this.state.searchValue == null || this.state.searchValue === '') return;

		this.setState({
			isLoading: true,
			alerts: [],
		});

		try {
			const res = await service.getApiPayload(this.state.searchValue);
			if (res != null) {
				this.setState({
					payload: res,
					isLoading: false,
				});
			}
		} catch (e) {
			this.setState({
				alerts: [{type:'danger', msg:'Problem contacting service.'}],
				isLoading: false,
			});
		}
	}

	render() {
		const currentEndpoint = this.state.searchValue != null ? this.state.searchValue : '';

		return (
			<Fragment>
				<SearchInput
					searchValue={this.state.searchValue}
					setSearchValue={this.setSearchValue}
					pressEnter={this.pressEnter}
					doSearch={this.doSearch}
					endpointList={this.state.endpointList}
					onDropdownSelect={this.onDropdownSelect} />
				<SearchUrlInfo 
					currentEndpoint={currentEndpoint} 
					params={this.state.params}
					onParamChange={this.onParamChange} />
				<Alerts alerts={this.state.alerts}/>
				{
					(this.state.isLoading)
						? <i className={"fas fa-spinner fa-7x fa-spin mt-3"}></i>
						: this.state.payload != null && <PayloadResponse payload={this.state.payload} />
				}
			</Fragment>
		)
	}
}

// stateless component to handle search input
function SearchInput(props) {
	const dropdownItems = props.endpointList.map((endpoint, index) => {
		return (
			<Dropdown.Item 
				key={index + endpoint.name} 
				onClick={() => props.onDropdownSelect(index)}>
					{endpoint.name}
			</Dropdown.Item>
		);
	});
	
	return (
		<Row className="enpoint-form">
			<Col sm={12}>
				<InputGroup className="mb-3">
					<DropdownButton
						as={InputGroup.Prepend}
						variant="outline-secondary"
						title="Endpoints"
						id="input-group-dropdown-1"
						className="endpoint-dropdown">
							{dropdownItems}
					</DropdownButton>
					<FormControl 
						id="endpoint" 
						aria-describedby="basic-addon3" 
						placeholder="Complete Endpoint"
						value={props.searchValue || ''}
						onChange={props.setSearchValue}
						onKeyPress={props.pressEnter} />
					<InputGroup.Append>
						<Button 
							variant="success" 
							size="sm"
							onClick={props.doSearch}>
								<i className="fas fa-search"></i> Search
						</Button>
					</InputGroup.Append>
				</InputGroup>
		</Col>
		</Row>
	);
}

// stateful component for complete url and params
class SearchUrlInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isUrlInfoOpen: false,
		}
	}
	
	render() {
		return (
			<Row className="enpoint-form">
				<Col sm={12}>
					<Card>
						<div className="url-info-area">
							<div className="endpoint">
								<div className="enpoint-title">Complete URL: </div>
								<div className="enpoint-url">{env.baseUrl + this.props.currentEndpoint}</div>
							</div>
							<Button 
								onClick={() => this.setState({ isUrlInfoOpen: !this.state.isUrlInfoOpen })}
								size="sm"
								variant="outline-info">
									{this.state.isUrlInfoOpen ? 'Hide' : 'Params'}
							</Button>
						</div>
						{
							this.state.isUrlInfoOpen && 
								<UrlParams params={this.props.params} onParamChange={this.props.onParamChange} />
						}
					</Card>
				</Col>
			</Row>
		);
	}
}

export default ApiTest;